import { render, staticRenderFns } from "./PesticideView.vue?vue&type=template&id=1049770e&scoped=true"
import script from "./PesticideView.vue?vue&type=script&lang=js"
export * from "./PesticideView.vue?vue&type=script&lang=js"
import style0 from "./PesticideView.vue?vue&type=style&index=0&id=1049770e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1049770e",
  null
  
)

export default component.exports